export const calculateHotelPriceHelper = (hotel) => {
  return Math.ceil(hotel.average_day_price)
}
